import React from "react";
import { Card, CardBody, CardTitle, Col } from "reactstrap";

const DossierValide = ({ listData }) => {
  const style = { fontFamily: "sans-serif" };
  return (
    <>
      {listData.allowed ? (
        <>
          <Col>
            <CardTitle style={{ color: "#555b21" }} className="mb-2">
              {listData.title}
            </CardTitle>
            <Card className="mini-stats-wid">
              <CardBody>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      {listData.header.map((item) => (
                        <th>{item}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {listData.data > 0 ? (
                      <>
                        {listData.data.map((item) => (
                          <tr key={item.id}>
                            <>
                              <td style={style}>{item.id}</td>
                              <td style={style}>{item.annee} </td>
                              <td style={style}>
                                {item.montant.toLocaleString("fr-FR", {
                                  style: "currency",
                                  currency: "EUR",
                                })}
                              </td>
                              <td style={style}>{item.retrocession} </td>
                            </>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={listData.header.length}>
                          Aucune donnée disponible
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
          <></>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default DossierValide;
